import {http} from '@/http'

// DEF-ADM-018 — Proveedores de servicio (ASOCIADO / TRANSPORTISTA).
// La ciudad la agrega el interceptor con el header X-City-Id.
export default {
  list(data, params) {
    return http.post('/api/v1/providers/list', data, {params})
  },
  save(data) {
    return http.post('/api/v1/providers', data)
  },
  get(id) {
    return http.get(`/api/v1/providers/${id}`)
  },
  update(id, data) {
    return http.put(`/api/v1/providers/${id}`, data)
  },
  changeStatus(id, status) {
    return http.put(`/api/v1/providers/${id}/status`, null, {
      params: { status },
    })
  },
  // Viajes asignados al proveedor (tab Viajes del detalle).
  rides(id, params) {
    return http.get(`/api/v1/providers/${id}/rides`, {params})
  },

  // ── Tarifas del proveedor (DEF-ADM-020) ──
  // direction: OUT (distrito → aeropuerto) | IN (aeropuerto → distrito).
  fares(id, direction) {
    return http.get(`/api/v1/providers/${id}/fares`, {params: {direction}})
  },
  saveFares(id, items) {
    return http.put(`/api/v1/providers/${id}/fares`, {items})
  },
  // Cuántas tarifas se copiarían y cuántas se pisarían, para confirmar antes.
  copyFaresPreview(id, sourceId) {
    return http.get(`/api/v1/providers/${id}/fares/copy-from/${sourceId}`)
  },
  copyFares(id, sourceId) {
    return http.post(`/api/v1/providers/${id}/fares/copy-from/${sourceId}`)
  },

  // ── Extras por viaje ──
  // Tarifa sugerida al asignar; found=false = no hay tarifa cargada.
  fareForBooking(bookingId, providerId, vehicleType) {
    return http.get(`/api/v1/bookings/${bookingId}/provider-fare`, {
      params: {provider_id: providerId, vehicle_type: vehicleType},
    })
  },
  // Corrige solo la tarifa del proveedor de un viaje ya asignado (conductor y
  // vehículo no se tocan). El backend rechaza si la liquidación ya se envió.
  updateBookingFare(bookingId, amount) {
    return http.put(`/api/v1/bookings/${bookingId}/provider-fare`, {provider_fare_amount: amount})
  },
  extras(bookingId) {
    return http.get(`/api/v1/bookings/${bookingId}/provider-extras`)
  },
  addExtra(bookingId, data) {
    return http.post(`/api/v1/bookings/${bookingId}/provider-extras`, data)
  },
  deleteExtra(id) {
    return http.delete(`/api/v1/provider-extras/${id}`)
  },
}
